import { render, staticRenderFns } from "./settingSelectList.vue?vue&type=template&id=fdfc36ba&scoped=true"
import script from "./settingSelectList.vue?vue&type=script&lang=js"
export * from "./settingSelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfc36ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdfc36ba')) {
      api.createRecord('fdfc36ba', component.options)
    } else {
      api.reload('fdfc36ba', component.options)
    }
    module.hot.accept("./settingSelectList.vue?vue&type=template&id=fdfc36ba&scoped=true", function () {
      api.rerender('fdfc36ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/btn/setting/settingSelectList.vue"
export default component.exports